import React, { ComponentProps, JSX } from 'react';
import { Switch as ChakraSwitch } from '@chakra-ui/react';

export const Switch = (props: Omit<ComponentProps<typeof ChakraSwitch>, 'colorScheme'>): JSX.Element => (
  <ChakraSwitch colorScheme="orange" {...props} />
);
